import { orchestrator } from 'satcheljs';
import { default as completeGetStartedTask } from '../actions/completeGetStartedTask';
import { GetStartedTaskId } from '../enums/GetStartedTaskId';
import { openPremiumUpsell } from '../actions/openPremiumUpsell';

orchestrator(openPremiumUpsell, () => {
    window.open('https://go.microsoft.com/fwlink/?linkid=2124558');
    completeGetStartedTask(GetStartedTaskId.PremiumUpsell);
});
